import React, { Component } from "react";
import TenantSummary from "../../models/tenants/TenantSummary";
import Table, {TableColumn} from "../Table";
import {TableRowProps} from "../TableRow";
import TableCell from "../TableCell";

interface TenantListProps {
    title: string;
    items?: TenantSummary[];
    enableRowLinks: boolean;
}

interface TenantListState {

}

export default class TenantList extends Component<TenantListProps, TenantListState>
{
    private static columns: TableColumn[] = [
    {
        title: "Tenant name",
        propertyPath: "tenantName",
        extraDetail: "Tenant id",
        enableSort: true,
        flex: 1
    },
    {
        title: "Number of schools",
        propertyPath: "schoolCount",
        enableSort: true,
        flex:1
    }];

    private readonly rowProps = (item: TenantSummary): TableRowProps => {
        return {
            to: `/cdb-admin/tenants/${item.tenantId}`,
            enableRowLink: this.props.enableRowLinks
        };
    }
    
    private cellForColumn = (item: TenantSummary, column: TableColumn, columnIndex: number): React.ReactElement<TableCell> | undefined => {
        
        if(column.propertyPath == "tenantName")
        {
            return (
                <TableCell key={columnIndex} flex={column.flex}>
                    <span>{item.tenantName}</span>
                    <span className={"cdb-table__extra-detail"}>{item.tenantId}</span>
                </TableCell>
            );
        }
        
        return undefined;
    }

    public componentDidMount() {

    }

    public render() {

        return (
            <Table
                title={this.props.title}
                loading={this.props.items === undefined}
                items={this.props.items!}
                columns={TenantList.columns}
                rowPropsForItem={this.rowProps}
                cellForColumn={this.cellForColumn}
                defaultSortColumnPath={'tenantName'}
                enableSort={true}>
                {this.props.children}
            </Table>
        );
    }
}